/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2019-12-23
12:29:41 * @modify date 2019-12-23 12:29:41 * @desc vue component */
<template>
  <div class="content-wrappper">
    <div class="row submission-container">
      <div class="col-xs-12 pb-15" v-if="permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER')">
        <span class="content-header">Activity Tracker</span>
      </div>
      <div
        class="col-md-12 tabs_pl pb-15"
        v-if="permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER')"
      >
        <div class="border_bt">
          <div class="row flex-widgets">
            <div
              class="col-xs-12 col-sm-4 col-md-4 tab_widget"
              v-if="permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_ACCOUNTS_COUNTER_WIDGET')"
            >
              <div class="border-tabs">
                <div class="account_header">
                  <div class="account_img_icon">
                    <img src="/static/images/icons/account_icon.svg" alt="account-icon" />
                  </div>
                  <div
                    class="account_header_content cursor-pointer"
                    @click="routeURL('/layout/activitytracker', 'accounts')"
                  >
                    {{ accountsInfo.name | capitalize }}
                  </div>
                  <div class="account_count">{{ accountsInfo.count }}</div>
                </div>
                <div class="account_body_content">
                  <div class="content_pb">
                    <div
                      class="account_rep cursor-pointer"
                      @click="routeFilter({ account_type: 'rep' }, 'accounts')"
                    >
                      Rep accounts
                    </div>
                    <div class="account_rep_count">
                      {{ getData(accountsInfo.summary_info, 'rep', 'count') }}
                    </div>
                  </div>
                  <div>
                    <div
                      class="account_rep cursor-pointer activity-height"
                      @click="routeFilter({ account_type: 'commercial' }, 'accounts')"
                    >
                      Commercial accounts
                    </div>
                    <div class="account_rep_count">
                      {{ getData(accountsInfo.summary_info, 'commercial', 'count') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-4 col-md-4 tab_widget"
              v-if="permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_USERS_COUNTER_WIDGET')"
            >
              <div class="border-tabs">
                <div class="user_header">
                  <div class="account_img_icon">
                    <img src="/static/images/icons/user_icon.svg" alt="user-icon" />
                  </div>
                  <div
                    class="account_header_content cursor-pointer"
                    @click="routeURL('/layout/activitytracker/', 'users')"
                  >
                    {{ usersInfo.name | capitalize }}
                    <el-popover
                      placement="right-end"
                      trigger="hover"
                      @show="infoActive = true"
                      @hide="infoActive = false"
                      class="main_popover"
                      width="550"
                    >
                      <img
                        class="info-img"
                        src="/static/images/icons/info_white_icon.svg"
                        v-if="!infoActive"
                        alt="info-icon"
                        slot="reference"
                      />
                      <img
                        class="info-img"
                        src="/static/images/icons/info_white_icon_active.svg"
                        v-if="infoActive"
                        alt="infoactive-icon"
                        slot="reference"
                      />
                      <div class="info-tabs">
                        <ul class="nav nav-tabs" role="tablist">
                          <li
                            role="presentation"
                            class="nav-item"
                            :class="{ active: activeTab == 'UserList' }"
                          >
                            <span class="nav-link" role="tab" data-toggle="tab">User List</span>
                          </li>
                        </ul>
                        <div class="info-text">
                          Some user roles can be associated with multiple accounts, such as
                          Consultant, PM, Support Admins. Each association is counted as a unique
                          user. This count differs from the Launchpad as no filters are applied so
                          that all user associations can be accessed.
                        </div>
                      </div>
                    </el-popover>
                  </div>
                  <div class="account_count">{{ usersInfo.count }}</div>
                </div>
                <div class="account_body_content">
                  <div class="content_pb cursor-pointer activity-height">
                    <div class="account_rep" @click="routeFilter({ account_type: 'rep' }, 'users')">
                      Rep users
                    </div>
                    <div class="account_rep_count">
                      {{ getData(usersInfo.summary_info, 'rep', 'count') }}
                    </div>
                  </div>
                  <div class="content_pb cursor-pointer activity-height">
                    <div
                      class="account_rep"
                      @click="routeFilter({ account_type: 'commercial' }, 'users')"
                    >
                      Commercial users
                    </div>
                    <div class="account_rep_count">
                      {{ getData(usersInfo.summary_info, 'commercial', 'count') }}
                    </div>
                  </div>
                  <div class="content_pb cursor-pointer activity-height">
                    <div
                      class="account_rep"
                      @click="routeFilter({ account_type: 'repcommercial' }, 'users')"
                    >
                      Rep/Commercial users
                    </div>
                    <div class="account_rep_count">
                      {{ getData(usersInfo.summary_info, 'both', 'count') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-4 col-md-4 tab_widget"
              v-if="permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_USERS_COUNTER_WIDGET')"
            >
              <div class="border-tabs">
                <table class="table m-0 text-center service-table custom-border">
                  <thead class="summary_header">
                    <tr class="service_header rounded-top">
                      <th scope="col" class="service_header_content"></th>
                      <th scope="col" class="service_header_content">This Week</th>
                      <th scope="col" class="service_header_content">Previous Week</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="premium-services summary_title">Total Accounts</td>
                      <td>
                        {{ getData(summaryInfo.summary_info, 'totalAccounts', 'count') }}
                      </td>
                      <td>
                        {{ getData(summaryInfoLastWeek.summary_info, 'totalAccounts', 'count') }}
                      </td>
                    </tr>
                    <tr>
                      <td class="premium-services summary_title">Rep Accounts</td>
                      <td>
                        {{ getData(summaryInfo.summary_info, 'repAccounts', 'count') }}
                      </td>
                      <td>
                        {{ getData(summaryInfoLastWeek.summary_info, 'repAccounts', 'count') }}
                      </td>
                    </tr>
                    <tr>
                      <td class="premium-services summary_title">
                        <div class="account_rep">
                          <span class="pr-5">Commercial accounts</span>
                          <router-link to="">
                            <i
                              @click="toggleDisplay"
                              class="fa fa-plus pr-5"
                              :class="{
                                'fa fa-plus pr-5': visible === false,
                                'fa fa-minus pr-5': visible === true
                              }"
                              aria-hidden="true"
                            ></i>
                          </router-link>
                        </div>
                      </td>
                      <td>
                        {{ getData(summaryInfo.summary_info, 'commercialAccounts', 'count') }}
                      </td>
                      <td>
                        {{
                          getData(summaryInfoLastWeek.summary_info, 'commercialAccounts', 'count')
                        }}
                      </td>
                    </tr>
                    <tr v-if="visible">
                      <td class="premium-services drill-down-title">Free accounts</td>
                      <td class="drill-down-value">
                        {{ getData(summaryInfo.summary_info, 'freeAccounts', 'count') }}
                      </td>
                      <td class="drill-down-value">
                        {{ getData(summaryInfoLastWeek.summary_info, 'freeAccounts', 'count') }}
                      </td>
                    </tr>
                    <tr v-if="visible">
                      <td class="premium-services drill-down-title">Trial accounts</td>
                      <td class="drill-down-value">
                        {{ getData(summaryInfo.summary_info, 'trialAccountsCount', 'count') }}
                      </td>
                      <td class="drill-down-value">
                        {{
                          getData(summaryInfoLastWeek.summary_info, 'trialAccountsCount', 'count')
                        }}
                      </td>
                    </tr>
                    <tr v-if="visible">
                      <td class="premium-services drill-down-title">Trial expired accounts</td>
                      <td class="drill-down-value">
                        {{ getData(summaryInfo.summary_info, 'trialExpiredAccounts', 'count') }}
                      </td>
                      <td class="drill-down-value">
                        {{
                          getData(summaryInfoLastWeek.summary_info, 'trialExpiredAccounts', 'count')
                        }}
                      </td>
                    </tr>
                    <tr v-if="visible">
                      <td class="premium-services drill-down-title">Premium fully paid</td>
                      <td class="drill-down-value">
                        {{ getData(summaryInfo.summary_info, 'premiumFullyPaidAccounts', 'count') }}
                      </td>
                      <td class="drill-down-value">
                        {{
                          getData(
                            summaryInfoLastWeek.summary_info,
                            'premiumFullyPaidAccounts',
                            'count'
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="premium-services summary_title">Total users added</td>
                      <td>
                        {{ getData(summaryInfo.summary_info, 'totalUsers', 'count') }}
                      </td>
                      <td>
                        {{ getData(summaryInfoLastWeek.summary_info, 'totalUsers', 'count') }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-md-12 tabs_pl pb-15"
        v-if="permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_PREMIUM_SERVICE_TABLE')"
      >
        <div class="border_bt">
          <div class="row widget_row">
            <div class="col-xs-12 col-sm-12 col-md-12 tab_widget">
              <div class="border-tabs">
                <div class="service_header">
                  <div class="account_img_icon">
                    <img src="/static/images/icons/account_icon.svg" alt="account-icon" />
                  </div>
                  <div class="account_header_content">Premium Services</div>
                </div>
                <div class="account_body_content overflow_scroll">
                  <table class="table table-striped table-bordered text-center service-table">
                    <thead>
                      <tr class="service_header">
                        <th scope="col" class="service_header_content">Service Name</th>
                        <th scope="col" class="service_header_content">REP accounts</th>
                        <th scope="col" class="service_header_content">Commercial accounts</th>
                        <th scope="col" class="service_header_content">Expiring in 30 days</th>
                        <th scope="col" class="service_header_content">
                          Expiring &gt; 30 days and &le; 45 days
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="service in services" :key="service.id">
                        <td
                          class="premium-services cursor-pointer"
                          @click="routeFilter({ services_registered: service.name }, 'accounts')"
                        >
                          {{ service.name }}
                          <span class="sub-text" v-if="service.name === 'Product Classification'"
                            ><br />Accounts w/multi-plans are counted once</span
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: service.name,
                                  account_type: 'rep'
                                },
                                'accounts'
                              )
                            "
                            >{{ service.rep || 0 }}</a
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: service.name,
                                  account_type: 'commercial'
                                },
                                'accounts'
                              )
                            "
                            >{{ service.nonRep || 0 }}</a
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: service.name,
                                  service_expiry: 'expiring30Days'
                                },
                                'accounts'
                              )
                            "
                            >{{ service.expiring_in30_days || 0 }}</a
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: service.name,
                                  service_expiry: 'expiring30To45Days'
                                },
                                'accounts'
                              )
                            "
                            >{{ service.expiring_in45_days || 0 }}</a
                          >
                        </td>
                      </tr>
                      <tr v-if="areTeamMembersAvailable">
                        <td
                          class="premium-services cursor-pointer"
                          @click="routeFilter({ services_registered: 'Team Members' }, 'accounts')"
                        >
                          Team Members
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: 'Team Members',
                                  account_type: 'rep'
                                },
                                'accounts'
                              )
                            "
                            >{{ teamMembersDetails.rep || 0 }}</a
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: 'Team Members',
                                  account_type: 'commercial'
                                },
                                'accounts'
                              )
                            "
                            >{{ teamMembersDetails.nonRep || 0 }}</a
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: 'Team Members',
                                  service_expiry: 'expiring30Days'
                                },
                                'accounts'
                              )
                            "
                            >{{ teamMembersDetails.expiring_in30_days || 0 }}</a
                          >
                        </td>
                        <td>
                          <a
                            href="javascript:void(0);"
                            class="premium-services cursor-pointer"
                            @click="
                              routeFilter(
                                {
                                  services_registered: 'Team Members',
                                  service_expiry: 'expiring30To45Days'
                                },
                                'accounts'
                              )
                            "
                            >{{ teamMembersDetails.expiring_in45_days || 0 }}</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 pb-15" v-if="permissions.includes('LAUNCHPAD_ADMIN_TOOLS')">
        <span class="content-header">Admin Tools</span>
      </div>
      <div
        class="col-xs-12 pb-15"
        v-if="permissions.includes('LAUNCHPAD_ADMIN_TOOLS_SERVICE_MANAGER')"
      >
        <div class="row border-1">
          <div class="row">
            <div class="col-xs-12 mlb-10">
              <span class="sub-content-header">Service Manager</span>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
              <div class="row border-2">
                <div class="col-md-3 col-xs-3 icon-container">
                  <div class>
                    <img src="/static/images/icons/submission_icon.svg" alt="submission-icon" />
                  </div>
                </div>
                <div class="col-md-9 col-xs-9 pr-0">
                  <div class="mt-5 desc-box">
                    <span
                      class="product-service cursor-pointer"
                      @click="routeURL('/layout/launchpad/submissionbuilderadmin')"
                    >
                      <span>Smart Builder</span>
                    </span>
                    <p class="product-content">
                      Service administrator access. Template management and service configurations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 pb-15" v-if="permissions.includes('LAUNCHPAD_ADMIN_TOOLS_OPERATIONS')">
        <div class="row border-1">
          <div class="row">
            <div class="col-xs-12 mlb-10">
              <span class="sub-content-header">Operations</span>
            </div>
          </div>
          <div class="row">
            <div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                <div class="row border-2">
                  <div class="col-md-3 col-xs-3 icon-container">
                    <div class>
                      <img src="/static/images/icons/submission_icon.svg" alt="submission-icon" />
                    </div>
                  </div>
                  <div class="col-md-9 col-xs-9 pr-0">
                    <div class="mt-5">
                      <span class="product-service">
                        <span data-v-481e9ed3>Smart Builder</span>
                      </span>
                      <div class="product-list-content row">
                        <div class="col-xs-8 pr-0">
                          <router-link to="/layout/launchpad/addcompany">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Add Company
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/companylist">List</router-link>
                        </div>
                      </div>
                      <div class="product-list-content row">
                        <div class="col-xs-8 pr-0">
                          <router-link to="/layout/launchpad/addproduct">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Add Product
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/productlist">List</router-link>
                        </div>
                      </div>
                      <div class="product-list-content row">
                        <div class="col-xs-8 pr-0">
                          <router-link to="/layout/launchpad/addproject">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Add Project
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/projectlist">List</router-link>
                        </div>
                      </div>
                      <div class="product-list-content row">
                        <div class="col-xs-8 pr-0">
                          <router-link to="/layout/launchpad/addconsultant">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Add Consultant
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/consultantslist">List</router-link>
                        </div>
                      </div>
                      <div class="product-list-content row">
                        <div class="col-xs-8 pr-0">
                          <router-link to="/layout/launchpad/addprojectmanager">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Add Project Manager
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/projectmanagerslist">List</router-link>
                        </div>
                      </div>
                      <div class="product-list-content row">
                        <div class="col-xs-8 pr-0 pr-5">
                          <router-link to="/layout/launchpad/activateservice">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Activate Service in
                            RAMS
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/activeaccountslist">List</router-link>
                        </div>
                      </div>
                      <div data-v-481e9ed3 class="product-list-content row" v-if="false">
                        <div class="col-xs-8 pr-0 pr-5">
                          <router-link to="/layout/launchpad/activaterationale">
                            <i class="fa fa-plus pr-5" aria-hidden="true"></i>Activate Rationale
                            Requets in RAMS
                          </router-link>
                        </div>
                        <div class="col-xs-4 br-list">
                          <router-link to="/layout/launchpad/activeaccountslist">List</router-link>
                        </div>
                      </div>
                      <div class="product-list-content row">
                        <div class="col-xs-12">
                          <router-link to="/layout/launchpad/exportaudit"
                            >View Smart Builder Audit Trail</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                <div class="row border-2">
                  <div class="col-md-3 col-xs-3 icon-container">
                    <div class>
                      <img src="/static/images/icons/submission_icon.svg" alt="submission-icon" />
                    </div>
                  </div>
                  <div class="col-md-9 col-xs-9 pr-0">
                      <div class="mt-5">
                        <span class="product-service">
                          <span data-v-481e9ed3>RAMS</span>
                        </span>
                        <div class="product-list-content row">
                          <div class="col-xs-8 pr-0">
                            <router-link to="/layout/launchpad/addsalesteam">
                              <i class="fa fa-plus pr-5" aria-hidden="true"></i
                              >Add Sales Team
                            </router-link>
                          </div>
                          <div class="col-xs-4 br-list">
                            <router-link to="/layout/launchpad/salesteamlist"
                              >List</router-link
                            >
                          </div>
                        </div>
                        <div class="product-list-content row">
                          <div class="col-xs-8 pr-0">
                            <router-link to="/layout/launchpad/addrepprojectmanager">
                              <i class="fa fa-plus pr-5" aria-hidden="true"></i
                              >Add REP Project Manager
                            </router-link>
                          </div>
                          <div class="col-xs-4 br-list">
                            <router-link to="/layout/launchpad/repprojectmanagerlist"
                              >List</router-link>
                          </div>
                        </div>
                        <div class="product-list-content row">
                          <div class="col-xs-8 pr-0">
                            <router-link to="/layout/launchpad/addrepconsultant">
                              <i class="fa fa-plus pr-5" aria-hidden="true"></i
                              >Add REP Consultant
                            </router-link>
                          </div>
                          <div class="col-xs-4 br-list">
                            <router-link to="/layout/launchpad/repconsultantlist"
                              >List</router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 pb-15" v-if="permissions.includes('LAUNCHPAD_ADMIN_TOOLS_SYSTEM')">
        <div class="row border-1">
          <div class="row">
            <div class="col-xs-12 mlb-10">
              <span class="sub-content-header">System</span>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 tab_widget">
              <div class="row border-2">
                <div class="col-md-3 col-xs-3 icon-container">
                  <div class>
                    <img src="/static/images/icons/dashboard_icon.svg" alt="dashbaord-icon" />
                  </div>
                </div>
                <div class="col-md-9 col-xs-9 pr-0">
                  <div class="mt-5 desc-box">
                    <span
                      class="product-service cursor-pointer"
                      @click="routeURL('/layout/launchpad/systemnotificationslist')"
                    >
                      <span>System Notifications</span>
                    </span>
                    <p class="product-content">
                      System-wide User notification management. Display advance warning messages and
                      system critical updates.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
              <div class="row border-2">
                <div class="col-md-3 col-xs-3 icon-container">
                  <div class>
                    <img src="/static/images/icons/rbac-admin.svg" alt="rbac-admin-icon" />
                  </div>
                </div>
                <div class="col-md-9 col-xs-9 pr-0">
                  <div class="mt-5 desc-box">
                    <span
                      class="product-service cursor-pointer"
                      @click="routeURL('/layout/launchpad/rbac/RBACManagement')"
                    >
                      <span>RBAC</span>
                    </span>
                    <p class="product-content">
                      System-wide user management. Providing user access for various services,
                      modules and sub modules
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import { Popover } from 'element-ui';
import { sortBy, cloneDeep } from 'lodash';
import { getActivityTrackerData, expiryDate } from '../../apis/launchPad';
import { getServiceDesc, getServiceInfo } from '../../apis/marketPlace';
import Loader from '../UIComponents/Loader.vue';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
// import BasePopover from '../Common/BasePopover.vue';

export default {
  mixins: [permissionsList],
  props: ['roleId'],
  data() {
    return {
      activeTab: 'UserList',
      infoActive: false,
      permissions: [],
      loaderStatus: false,
      accountsInfo: [],
      usersInfo: [],
      summaryInfo: [],
      summaryInfoLastWeek: [],
      services: [],
      teamMembersDetails: {},
      visible: false
    };
  },
  components: {
    Loader,
    // BasePopover,
    'el-popover': Popover
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
    }
  },
  computed: {
    areTeamMembersAvailable() {
      return Object.keys(this.teamMembersDetails).length;
    }
  },
  async created() {
    if (this.roleId === 5 || this.roleId === 11) {
      await this.getActivityTrackerData();
      await this.getServicesList();
    }
    await this.validateFeatures();
  },
  methods: {
    toggleDisplay() {
      this.visible = !this.visible;
    },
    async validateFeatures() {
      this.loaderStatus = true;
      this.permissions = [];
      const servicesList = ['LAUNCHPAD'];
      const modulesList = ['LAUNCHPAD_ACTIVITY_TRACKER', 'LAUNCHPAD_ADMIN_TOOLS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      // Both modules are disabled
      if (
        !this.permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER') &&
        !this.permissions.includes('LAUNCHPAD_ADMIN_TOOLS')
      ) {
        this.$router.push('/layout/PermissionAccess');
      }
      // Activity Tracker module enabled and sub-modules disabled
      if (
        this.permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER') &&
        !this.permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_ACCOUNTS_COUNTER_WIDGET') &&
        !this.permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_USERS_COUNTER_WIDGET') &&
        !this.permissions.includes('LAUNCHPAD_ACTIVITY_TRACKER_PREMIUM_SERVICE_TABLE')
      ) {
        this.permissions = this.permissions.filter(
          (permission) => permission !== 'LAUNCHPAD_ACTIVITY_TRACKER'
        );
      }
      // Admin Tools module enabled and sub-modules disabled
      if (
        this.permissions.includes('LAUNCHPAD_ADMIN_TOOLS') &&
        !this.permissions.includes('LAUNCHPAD_ADMIN_TOOLS_SERVICE_MANAGER') &&
        !this.permissions.includes('LAUNCHPAD_ADMIN_TOOLS_OPERATIONS') &&
        !this.permissions.includes('LAUNCHPAD_ADMIN_TOOLS_SYSTEM')
      ) {
        this.permissions = this.permissions.filter(
          (permission) => permission !== 'LAUNCHPAD_ADMIN_TOOLS'
        );
      }
      this.loaderStatus = false;
    },
    getData(array, value, key) {
      if (!array || !array.length) {
        return '';
      }
      return array.find((arr) => arr.name === value)[key];
    },
    async getActivityTrackerData() {
      this.loaderStatus = true;
      const data = await getActivityTrackerData();
      data.data.forEach((widget) => {
        if (widget.name === 'accounts') {
          this.accountsInfo = widget;
        } else if (widget.name === 'users') {
          this.usersInfo = widget;
        } else if (widget.name === 'summary') {
          this.summaryInfo = widget;
        } else if (widget.name === 'summaryLastWeek') {
          this.summaryInfoLastWeek = widget;
        }
      });
      this.loaderStatus = false;
    },
    routeURL(url, menu) {
      if (menu === 'users') {
        this.$router.push({
          name: 'activitytracker',
          params: { selectedMenu: 'users' }
        });
      } else if (menu === 'loginactivity') {
        this.$router.push({
          name: 'activitytracker',
          params: { selectedMenu: 'loginactivity' }
        });
      } else {
        this.$router.push(url);
      }
    },
    routeFilter(filter, selectedMenu) {
      this.$router.push({
        name: 'activitytracker',
        params: {
          filter,
          selectedMenu
        }
      });
    },
    async getServicesList() {
      this.loaderStatus = true;
      const repAndNonRepCountForTeamMemberAndServices = await await getServiceInfo();
      const repAndNonRepServicesCount = repAndNonRepCountForTeamMemberAndServices.service;
      let serviceSummary = await getServiceDesc();
      const expiryCountForTeamMemberAndServices = await expiryDate();
      const expiryCountForServices = expiryCountForTeamMemberAndServices.service;
      serviceSummary = cloneDeep(
        serviceSummary.filter(
          (service) => service.id !== 5 && service.id !== 8 && service.id !== 9 && service.id !== 10
        )
      );
      repAndNonRepServicesCount.forEach((service) => {
        for (let i = 0; i < serviceSummary.length; i += 1) {
          if (service.id === serviceSummary[i].id) {
            if (service.rep_client) {
              serviceSummary[i].rep = service.accounts_count;
            } else {
              serviceSummary[i].nonRep = service.accounts_count;
            }
          }
        }
      });
      expiryCountForServices.forEach((service) => {
        for (let i = 0; i < serviceSummary.length; i += 1) {
          if (service.id === serviceSummary[i].id) {
            serviceSummary[i].expiring_in30_days = service.expiring_in30_days;
            serviceSummary[i].expiring_in45_days = service.expiring_in45_days;
          }
        }
      });
      this.getTeamMembersDetailsOrCount(
        repAndNonRepCountForTeamMemberAndServices,
        expiryCountForTeamMemberAndServices
      );
      this.services = sortBy(serviceSummary, 'sequence');
      this.loaderStatus = false;
    },
    getTeamMembersDetailsOrCount(ServicesListForReporNonRep, expiryListForServices) {
      if (ServicesListForReporNonRep.add_on.length || expiryListForServices.add_on.length) {
        const teamMembersDetails = ServicesListForReporNonRep.add_on.reduce((acc, details) => {
          if (details.id === 1) {
            const key = details.rep_client ? 'rep' : 'nonRep';
            acc[key] = details.accounts_count;
            return acc;
          }
          return acc;
        }, {});
        const teamMembersDetailsFromExpiryListForServices = expiryListForServices.add_on.find(
          (details) => details.id === 1
        );
        teamMembersDetails.expiring_in30_days = teamMembersDetailsFromExpiryListForServices
          ? teamMembersDetailsFromExpiryListForServices.expiring_in30_days
          : '';
        teamMembersDetails.expiring_in45_days = teamMembersDetailsFromExpiryListForServices
          ? teamMembersDetailsFromExpiryListForServices.expiring_in45_days
          : '';
        this.teamMembersDetails = JSON.parse(JSON.stringify(teamMembersDetails));
      }
    }
  }
};
</script>
<style scoped>
.info-text {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.7);
  text-align: left;
  word-break: break-word;
  margin-top: 10px;
}
.info-img {
  height: 20px;
  width: 20px;
  vertical-align: text-top;
  margin-top: 5px;
}
.submission-container {
  margin: 0;
  padding: 15px 10px;
}
.submission-container .content-header,
.submission-container .sub-content-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.submission-container .sub-content-header {
  font-weight: 500;
}
.submission-container .border-1 {
  border: 1px solid #d3d6d9;
  box-sizing: border-box;
  border-radius: 7px;
  margin: 0;
  padding: 15px;
}
.submission-container .border-2 {
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 7px;
  padding: 15px 8px 15px 15px;
  margin: 0;
}
.pb-15 {
  padding-bottom: 15px;
}
.mlb-10 {
  margin: 0 0 10px 10px;
}
.pr-0 {
  padding-right: 0;
}
.pr-5 {
  padding-right: 5px;
}
.mt-5 {
  margin-top: 5px;
}
.table > thead > tr > th:last-child {
  padding-left: 7px;
}
.text-center {
  text-align: center;
}
.submission-container .icon-container {
  background: #0b3c61;
  border: 1px solid #174c76;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 15px 12px;
  max-width: 80px;
  min-height: 80px;
}
.submission-container .icon-container img {
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.submission-container .product-service {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 19px;
  color: #174c76;
  margin-bottom: 5px;
  margin-top: 5px;
}
.cursor-pointer.activity-height,
.premium-services.cursor-pointer {
  cursor: pointer;
}
.premium-services.cursor-pointer {
  height: 66px;
}
.service-table tbody td a {
  color: #333;
  text-decoration: underline !important;
}
.service-table.custom-border > thead > tr > th:nth-child(1) {
  border-radius: 10px 0px 0px 0px;
}
.service-table.custom-border > thead > tr > th:nth-last-child(1) {
  border-radius: 0px 10px 0px 0px;
}
.service-table.custom-border thead > tr > th {
  border: none;
  padding: 14px 10px;
}
.service-table.custom-border tbody > tr > td {
  padding: 10px !important;
  color: rgba(0, 0, 0, 0.7);
}

.service-table.custom-border tbody > tr > td.drill-down-title {
  padding-left: 32px !important;
}
.sub-text {
  font-size: 14px;
}
.submission-container .product-content {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 7px;
  margin-bottom: 0;
}
.desc-box {
  height: 78px;
  overflow-y: hidden;
  scrollbar-width: thin;
}
.desc-box:hover {
  overflow-y: auto;
}
.submission-container .product-list-content {
  margin-top: 7px;
  margin-bottom: 0;
  font-weight: normal;
  font-family: Roboto;
  font-size: 16px;
}
.submission-container .product-list-content a {
  color: #4988be;
  font-size: 14px;
}
.submission-container .br-list {
  border-left: 1px solid #4988be;
}
.submission-container .product-list-content a:hover {
  color: #337ab7;
}
.border-tabs {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  background: #ffffff;
  height: 100%;
}
.summary_title {
  text-align: left;
}

.drill-down-title {
  text-align: left;
}

.drill-down-value {
  text-align: center;
}
.account_header,
.user_header,
.summary_header,
.logins_header,
.service_header {
  background: #4c9e45;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 37px;
  color: #ffffff;
}
.user_header,
.summary_header,
.service_header {
  background: #0b3c61 !important;
}

.logins_header {
  background: #ffffff;
  color: #0b3c61 !important;
  border-bottom: 0.5px solid #174c76;
}
.uniquelogs_count,
.account_uniquelog_content,
.account_rep_count,
.account_rep,
.account_img_icon,
.account_header_content,
.account_count {
  display: inline-block;
}
.account_img_icon > img {
  margin-bottom: 5px;
}
.account_uniquelog_content {
  font-size: 20px;
}
.uniquelogs_count {
  font-size: 20px;
}
.account_header_content,
.account_uniquelog_content {
  margin-left: 10px;
}
.account_img_icon,
.account_header_content,
.account_count {
  color: #ffffff;
}
.service_header_content {
  color: #ffffff;
  text-align: center;
}
.table > thead:first-child > tr:first-child > th {
  cursor: default;
}
.account_body_content {
  padding: 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal !important;
  font-size: 18px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
}
.account_rep_count {
  font-size: 20px;
}
.account_count,
.account_rep_count,
.uniquelogs_count {
  float: right;
}
.account_count,
.uniquelogs_count {
  font-weight: normal;
}
.content_pb {
  padding-bottom: 20px;
}
.content_sub {
  padding-left: 25px;
}
.tabs_pl {
  padding-left: 0px;
  padding-right: 0px;
}
.border_bt {
  margin: 0px 15px;
  padding-bottom: 20px;
  border-bottom: 0.5px solid #808080;
}
.widget_row {
  margin-right: 0px;
  width: 100%;
}
@media screen and (max-width: 1024px) {
  .tab_widget {
    padding-bottom: 20px;
  }
  .account_header,
  .user_header,
  .summary_header,
  .logins_header,
  .service_header {
    font-size: 18px;
  }
  .account_body_content {
    font-size: 16px;
  }
  .account_uniquelog_content {
    font-size: 18px;
  }
  .account_rep_count {
    font-size: 18px;
  }
  .uniquelogs_count {
    font-size: 18px;
  }
}
@media screen and (max-width: 767px) {
  .overflow_scroll {
    overflow-x: scroll;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .account_body_content {
    min-height: 132px;
  }
  .account_header,
  .user_header,
  .summary_header,
  .logins_header {
    min-height: 70px;
    display: table;
    width: 100%;
  }
  .uniquelogs_count,
  .account_uniquelog_content,
  .account_rep_count,
  .account_img_icon,
  .account_header_content,
  .account_count {
    display: table-cell;
    vertical-align: middle;
  }
  .account_count,
  .uniquelogs_count {
    float: unset;
    text-align: right;
  }
  .account_uniquelog_content {
    width: 50%;
    line-height: 20px;
  }
  .account_rep {
    width: 60%;
    line-height: 20px;
  }
}
@media screen and (min-width: 767px) {
  .flex-widgets {
    display: flex;
  }
}
@media screen and (max-width: 767px) {
  .premium-services.cursor-pointer {
    height: 20vh;
  }
}
::v-deep .main_popover .popover.right {
  border: none;
  /*   width: 550px; */
}
::v-deep .main_popover .popover.right > .arrow {
  border: none;
  opacity: 1;
  margin-top: 2px;
}
::v-deep .main_popover .popover-content {
  padding: 20px 12px 12px;
}
::v-deep .main_popover .info-tabs .info-text {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.7);
  text-align: left;
  word-break: break-word;
  margin-top: 10px;
}
</style>
